"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformColorToString = void 0;
var utils_1 = require("@daytrip/utils");
Object.defineProperty(exports, "transformColorToString", { enumerable: true, get: function () { return utils_1.transformColorToString; } });
//# sourceMappingURL=transformColorToString.js.map